import { AxiosError, AxiosResponse } from "axios";

/**
 * Mirror of the backend error-code contract in `PocketFilms/error_codes.py`.
 *
 * Branch on `code`, never on `message`: the backend states outright that
 * message text may be reworded at any time without a client release, so a
 * string comparison is a branch that dies silently the day someone edits a
 * sentence. Only the codes this app actually branches on are listed; an
 * unrecognised code should fall through to the generic error path.
 */
export const AuthErrorCode = {
  userNotFound: "error_user_not_found",
  phoneRequired: "error_phone_required",
  invalidPhone: "error_invalid_phone",
  invalidChannel: "error_invalid_channel",
  otpSendFailed: "error_otp_send_failed",
  otpSendRateLimited: "error_otp_send_rate_limited",
} as const;

interface CodedBody {
  code?: string;
  message?: string;
}

/** The machine-readable code on a rejected request, if the server sent one. */
export const errorCodeOf = (error: unknown): string | undefined =>
  error instanceof AxiosError
    ? (error.response?.data as CodedBody | undefined)?.code
    : undefined;

/**
 * The code on a *successful* response, if it is really a failure in disguise.
 *
 * `otp/send/phone` answers some rejections with `status=200` carrying a code —
 * an unparseable number on the create-if-missing path, for one — so a caller
 * that only checks the HTTP status will happily advance to an OTP screen for a
 * code that was never sent.
 */
export const failureCodeOf = (
  response: AxiosResponse<CodedBody>
): string | undefined => response.data?.code;
